export default __webpack_public_path__ + "static/media/Astro_Virgo_Black.5dd3106b.png";